import React, { useEffect, useState } from 'react'
import { SubmitHandler, useForm } from 'react-hook-form'
import { FormattedMessage, useIntl } from 'react-intl'

import s from './styles.module.scss'

import { SubscribeSimplifiedModalTypeEnum } from '../../utils/subscribe-simplified-modal-type.enum'
import { pushToGTM } from '../../../../../../utils/pushToGTM'
import regex from '../../../../../../utils/regex'
import { Button, BUTTON_COLOR } from '../../../../../atoms'
import { InputText } from '../../../../../molecules'
import { HelperTextProps } from '../../../login-modal-subscribe/helper-text/HelperText'
export interface InputsSubscribeSimplified {
  email: string
}

export const SubscribeSimplifiedModalForm = ({
  onAccessResults,
  isLoading,
  setModalSubscribeSimplifiedType,
  helperText,
}: {
  onAccessResults: ({ email }: { email: string }) => void
  isLoading: boolean
  setModalSubscribeSimplifiedType: React.Dispatch<
    React.SetStateAction<SubscribeSimplifiedModalTypeEnum>
  >
  helperText: null | HelperTextProps
}) => {
  const [fixedEmail, setFixedEmail] = useState<string>('')
  const intl = useIntl()
  const {
    control,
    watch,
    handleSubmit,
    setError,
    formState: { errors },
  } = useForm<InputsSubscribeSimplified>({
    defaultValues: { email: '' },
    mode: 'onChange',
  })

  const onSubmit: SubmitHandler<InputsSubscribeSimplified> = async ({
    email,
  }) => {
    onAccessResults({ email })

    pushToGTM({
      event: 'simple_signup_init',
      email,
    })

    pushToGTM({
      event: 'subscribe',
      'register-form-email': email,
    })
  }

  useEffect(() => {
    if (helperText) {
      setError('email', { type: helperText.type, message: helperText.message })
    }
  }, [helperText])

  useEffect(() => {
    if (fixedEmail) {
      setFixedEmail('')
    }
  }, [watch('email')])

  return (
    <>
      <form className={s.form} onSubmit={handleSubmit(onSubmit)}>
        <InputText
          isErrorUnderInput={true}
          control={control}
          name='email'
          label={
            <FormattedMessage
              id='ui.SubscribeSimplifiedModalForm.email.label'
              defaultMessage='E-mail professionnel'
            />
          }
          labelProps={{
            className: s.label,
          }}
          rules={{
            validate: {
              required: (email: string) => {
                if (email === fixedEmail) {
                  return (
                    !!email ||
                    intl.formatMessage({
                      id: 'ui.SubscribeSimplifiedModalForm.email.label.required',
                      defaultMessage: 'Une adresse e-mail est requise.',
                    })
                  )
                }
              },
              email: (email: string) => {
                if (email === fixedEmail) {
                  return (
                    regex.email.test(email) ||
                    intl.formatMessage({
                      id: 'ui.SubscribeSimplifiedModalForm.email.label.regex',
                      defaultMessage: "Respecter le bon format d'e-mail",
                    })
                  )
                }
              },
            },
          }}
          inputProps={{
            type: 'text',
            'aria-label': intl.formatMessage({
              id: 'ui.SubscribeSimplifiedModalForm.email.label.aria',
              defaultMessage: 'entrez votre e-mail',
            }),
            'aria-required': 'true',
            className: s.inputBorderRadius,
          }}
          placeholder={intl.formatMessage({
            id: 'ui.SubscribeSimplifiedModalForm.email.label.placeholder',
            defaultMessage: 'Entrer votre adresse e-mail professionnelle',
          })}
        />

        <div className={s.buttonWrapper}>
          <Button
            id='finish-subscribe'
            className={s.loginBtn}
            loading={isLoading}
            onClick={() => setFixedEmail(() => watch('email'))}
            type='submit'
            fullWidth={true}
          >
            <span>
              <FormattedMessage
                id='ui.SubscribeSimplifiedModalForm.seeResults'
                defaultMessage='Voir les résultats'
              />
            </span>
          </Button>
          {errors.email?.message && fixedEmail && (
            <Button
              onClick={() => {
                setModalSubscribeSimplifiedType(
                  SubscribeSimplifiedModalTypeEnum.NOT_PROFESSIONAL_EMAIL,
                )
              }}
              className={s.btnHelper}
              fullWidth={true}
              color={BUTTON_COLOR.TERTIARY}
            >
              <FormattedMessage
                id='ui.SubscribeSimplifiedModalForm.noProEmail'
                defaultMessage='Pas d’e-mail professionnel ?'
              />
            </Button>
          )}
        </div>
      </form>
    </>
  )
}
